import React from 'react';
import ErrorFallback from '../ErrorFallback';
import RouteContainer from '../layout/RouteContainer';

type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  removeRouterWrapper?: boolean;
  contact?: ContactProps;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

type ContactProps = {
  message: string | null | undefined;
  contactNumber: string | null | undefined;
}

class ErrorBoundary extends React.PureComponent<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  } 

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}

const renderChildren = ({ children,  removeRouterWrapper}: ErrorBoundaryProps) => removeRouterWrapper === true ? children : <RouteContainer>{children}</RouteContainer>;

export const withErrorBoundary = (Component: React.ComponentType, fallback = <ErrorFallback message={"We seem to be having some difficulties"} />) => (
    <ErrorBoundary fallback={fallback}>
        <Component />
    </ErrorBoundary>
);

export const ErrorBoundaryWithDefault: React.FC<ErrorBoundaryProps> = (props) => (
    <ErrorBoundary fallback={<ErrorFallback message={"We seem to be having some difficulties"} contact={props.contact} />}>
        {renderChildren(props)}
    </ErrorBoundary>
);

export default ErrorBoundary;
